import { render, staticRenderFns } from "./createLive.vue?vue&type=template&id=f5e48bbe&scoped=true"
import script from "./createLive.vue?vue&type=script&lang=js"
export * from "./createLive.vue?vue&type=script&lang=js"
import style0 from "./createLive.vue?vue&type=style&index=0&id=f5e48bbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e48bbe",
  null
  
)

export default component.exports